import Api from 'utils/api'

export const fetchProjects = ({
  limit,
  offset,
  ordering,
  search,
  department,
}) => Api.get(['projects'], { limit, offset, ordering, search, department })
